import {useEffect, useRef, useState} from "react";
import {USER_ADDRESS} from "../constants";
import {toast} from "react-toastify";
import {weaponsContract} from "../constants/contract";
import {NftContract} from "../components/functions/NftContract";
import element from "../images/a-dragonsblade-sand.png";
import {weaponsAbi} from "../constants/weaponsAbi";

const MintWeapons = () => {
  const [loading, setLoading] = useState(true);
  const totalSupply = useRef(0);
  const [availableTokenCount, setAvailableTokenCount] = useState(0);
  const currentMintPrice = useRef(0);
  const [mintAmount, setMintAmount] = useState(1);
  const [maxMintAmount, setMaxMintAmount] = useState(0);
  const [nftContract] = useState(new NftContract());
  const saleInfo = useRef([]);
  const saleStarted = useRef(false);

  useEffect(async () => {
    if (!USER_ADDRESS) {
      toast.error('Connect your wallet!', {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
      });

    }
    await initialize();
  }, [])

  const initialize = async () => {
    totalSupply.current = await nftContract.totalSupply(weaponsAbi, weaponsContract);
    saleStarted.current = await nftContract.saleStarted(weaponsAbi, weaponsContract);
    setAvailableTokenCount(await nftContract.availableTokenCount(weaponsAbi, weaponsContract));
    saleInfo.current = await nftContract.saleInfo(weaponsAbi, weaponsContract);
    currentMintPrice.current = (parseInt(saleInfo.current['price']));

    if (saleInfo.current['saleType'] === '0') {
      setMaxMintAmount(await nftContract.whitelistMintAmount(weaponsAbi, weaponsContract));
    } else {
      setMaxMintAmount(saleInfo.current['maxTokens']);
    }
  }

  const mint = async () => {
    const price = currentMintPrice.current;
    await nftContract.mint(weaponsAbi, weaponsContract, price, mintAmount, setLoading, initialize)
  }

  const handleMintAmount = (amount) => {
    if (amount > maxMintAmount) {
      setMintAmount(maxMintAmount);
    } else {
      setMintAmount(amount);
    }
  }

  import('../Elements-Minting.css')
  return <div>
    <section className="u-clearfix u-custom-color-1 elements-minting-u-section-1" id="sec-0c1b">
      <div className="u-clearfix u-sheet u-sheet-1">
        <div className="u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
          <div className="u-layout">
            <div className="u-layout-row">
              <div className="u-container-style u-layout-cell u-size-30 u-layout-cell-1">
                <div className="u-container-layout u-valign-middle u-container-layout-1">
                  <img className="u-expanded-width u-image u-image-default u-preserve-proportions u-image-1"
                       src={element} alt="" data-image-width="1080" data-image-height="920"/>
                </div>
              </div>
              <div className="u-align-center u-container-style u-layout-cell u-size-30 u-layout-cell-2">
                <div
                  className="u-container-layout u-valign-bottom-lg u-valign-bottom-md u-valign-top-xl u-container-layout-2">
                  <p className="u-text u-text-1">
                    <span style={{fontSize: '1.5rem', fontWeight: '700'}}> Mint your Weapons.</span>
                    <br/>
                    <span style={{fontWeight: '700'}}>Elements Minted :&nbsp;{totalSupply.current - availableTokenCount}&nbsp;/&nbsp;{totalSupply.current}</span>
                    <br/>
                    <br/>
                    <span style={{textDecoration: 'underline !important'}}>Pre Sale:</span>
                    <br/>15th of October 2022 at 4:00 pm UTC +0<br/>
                    <br/>
                    <span style={{textDecoration: 'underline !important'}}>Public Sale:</span>
                    <br/>15th of October 2022 at 6:00 PM UTC +0<br/>
                    <br/>
                    <span style={{ fontWeight: '700' }}>Prices:</span>
                    <br/>
                    <br/>
                    <span style={{textDecoration: 'underline !important'}}>Pre-Sale:</span>
                    <br/>FREE<br/>3 Mints Max<br/>
                    <br/>
                    <span style={{textDecoration: 'underline !important'}}>Public sale:</span>
                    <br/>FREE<br/>Max 1 NFTS per TX (Unlimited TXs)<br/>
                    <br/>
                    <span style={{ fontSize: '0.75rem'}}>After signing your TX. you can find your Weapon NFTs in the "<a
                      href="/weaponAssets"
                      className="u-active-none u-border-none u-btn u-button-style u-hover-none u-none u-text-palette-1-base u-btn-1">My Weapons</a>" Tab in the menu.
                    </span>
                    <br/>
                  </p>
                  {/*{maxMintAmount > 0 ? <>*/}
                  {/*<p className="u-text u-text-2">Amount of Weapons you want to Mint</p>*/}
                  {/* <input type="number" max={maxMintAmount} min={1} value={mintAmount} onChange={num=>handleMintAmount(Number(num.target.value))} className="u-shape u-shape-rectangle u-white u-shape-1"></input>*/}
                  {/*<button onClick={()=>mint()}*/}
                  {/*   className="u-btn u-btn-round u-button-style u-hover-palette-1-light-1 u-palette-1-base u-radius-50 u-btn-2">$FREE</button> </> : null }*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

}
export default MintWeapons;
